<!-- 港区数据对比 -->
<template>
  <el-dialog
    class="contrast"
    width="80%"
    :visible.sync="visible"
    :before-close="cancel"
    :close-on-click-modal="false"
    :title="$t('Message.PortAreaDataComparison')"
  >
    <div class="harbour-data-compare">
      <div class="harbour-compare-tit">{{ $t('Message.Explain') }}<font class="none">{{ $t('Message.BlackIsTheInputData') }}</font><font class="blue">{{ $t('Message.BlueThePortAreaData') }}</font>
        <p>{{ $t('Message.ClickEnteredDataPleaseOperation') }}</p>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableList"
        height="300px"
        border
        :span-method="objectSpanMethod"
        @cell-mouse-enter="hoverRow"
        @cell-mouse-leave="leaveRow"
        @selection-change="handleSelect"
      >
        <el-table-column type="selection" :selectable="selectable" width="55" />
        <el-table-column prop="type" width="110" :label="$t('Message.ImportMode')">
          <template slot="header">
            <span>{{ $t('Message.ImportMode') }}</span>
            <el-tooltip
              placement="right-start"
              :content="$t('queryJob.ImportMode')"
            >
              <i class="el-icon-question" style="color:#1989fa;font-size:18px;" />
            </el-tooltip>

          </template>
        </el-table-column>

        <el-table-column prop="soNo" :label="$t('SeaExport.SoNo')" width="160">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.soNo }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="eqSize" :label="$t('SeaExport.ContainerSize')" width="60">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.eqSize }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="eqType" :label="$t('SeaExport.ContainerType')" width="60">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ mappingEqType(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="source" :label="$t('queryJob.DataSource')" width="120">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.source === 1 ? $t('queryJob.SystemInput') : $t('queryJob.PortAreaData') }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="containerNo" :label="$t('Payment.containerNo')" width="120">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.containerNo }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="sealNo" :label="$t('SeaExport.SealNo')" width="120">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.sealNo }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="quantity" :label="$t('SeaExport.Quantity')" width="60">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.hasOwnProperty('showQuantity') ? scope.row.showQuantity : scope.row.quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="weight" :label="$t('SeaExport.Weight')" width="80">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.hasOwnProperty('showWeight') ? scope.row.showWeight : scope.row.weight }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="cubage" :label="$t('SeaExport.Cubage')" width="80">
          <template slot-scope="scope">
            <span :class="scope.row.form === 'G' ? 'blue' : 'none' ">{{ scope.row.hasOwnProperty('showCubage') ? scope.row.showCubage : scope.row.cubage }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button :disabled="!isEdit" type="primary" @click="sumbitHarbour">{{ $t('queryJob.UpdateToPortAreaData') }}</el-button>
      <el-button @click="cancel">{{ $t('Message.Cancel2') }}</el-button>
    </div>

    <!-- 多行关单行移入显示弹窗 -->
    <transition name="el-fade-in-linear">
      <div v-show="rightShow" class="floating">
        <div v-for="(item, index) in detailData" :key="index" class="mar-tp">
          <span>{{ item.soNo }}: </span>
          <div style="margin-left:10px;">
            <span>件数：{{ item.quantity }}</span>
            <span>毛重：{{ item.weight }}</span>
            <span>体积：{{ item.cubage }}</span>
          </div>
        </div>
      </div>
    </transition>

  </el-dialog>
</template>

<script>
import lodash from 'lodash'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import * as CommonUtil from '@/utils/commonUtil'

export default {
  name: 'LclCompareHarbourDialog',
  props: {
    visible: { type: Boolean, default: () => false },
    job: { type: Object, default: () => {}, require: true },
    harbourSource: { type: Array, default: () => [], require: true }, // 港区数据
    dataSource: { type: Array, default: () => [], require: true },
    lclSlaveSoNo: { type: Object, default: () => {}, require: true },
    hqFlag: { type: Boolean, default: () => true },
    hcFlag: { type: Boolean, default: () => true },
    containerHeightFlag: { type: Boolean, default: () => true },
    hQHCFlag: { type: Boolean, default: () => false },
    isEdit: { type: Boolean, default: () => true }
  },
  data() {
    return {
      rightShow: false,
      isShow: false,
      index: '',
      tableList: [],
      initTableList: [],
      selection: [],
      initData: [],
      addNewGoods: [],
      showExpand: [],
      container: [],
      poItems: [],
      selectMap: {},
      detailData: [],
      changeUsage: {} // 需要变更的关单号
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.hanldeCompareData()
      }
    },
    job(newVal, oldVal) {
      if (newVal) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.container = lodash.cloneDeep(this.dataSource)
    },
    hoverRow(row) {
      // 多行关单号 && 港区数据
      if (row.multiline && row.source === 2) {
        this.rightShow = true
        this.detailData = row.detailData
      }
    },
    leaveRow(row) {
      // 多行关单号 && 港区数据
      if (row.multiline && row.source === 2) {
        this.rightShow = false
      }
    },
    // 转换箱型箱种
    convert(item) {
      if (item.eqSize) {
        const eqSize = new RegExp("'", '')
        item.eqSize = item.eqSize.replace(eqSize, '')
      }
      if (item.eqType) {
        item.eqType = item.eqType.toUpperCase()
      }
    },
    // 对数据按需求进行对比
    hanldeCompareData() {
      this.tableList = []
      if (this.dataSource.length > 0) {
        this.dataSource.forEach((item) => {
          if (item.containerUsage.length > 0) {
            // 获取当前箱子的箱型箱种赋值给小票
            item.containerUsage.forEach((v) => {
              v.eqType = item.eqType
              v.eqSize = item.eqSize
            })
          }
          this.tableList.push(...JSON.parse(JSON.stringify(item.containerUsage)))
          this.initTableList.push(...item.containerUsage)
        })
      }
      // this.tableList.forEach((item) => {
      //   if (item.soNo === 'E142202388266A02') {
      //     item.soNo = 'E142202388266A01'
      //     item.eqType = 'HQ'
      //     item.eqSize = '40'
      //   }
      // })
      // this.harbourSource.forEach((v) => {
      // if (v.soNo === 'E142202388266A01') {
      //   v.containerHeightCn = "9'6''"
      //   v.eqType = 'GP'
      //   v.eqSize = '40'
      // }
      // v.eqTypeArr = CommonUtil.transformationEqType(v.eqType, v.containerHeightCn)
      // })
      console.log('未处理的系统数据============', this.dataSource)
      console.log('系统录入的数据============', this.tableList)
      console.log('港区数据============', this.harbourSource)
      const harbourData = []
      const filterArr = []
      const soNoId = []
      // 过滤港区重复数据，避免合并陷入死循环
      for (const item of this.harbourSource) {
        if (soNoId.indexOf(item['soNo']) === -1) {
          soNoId.push(item['soNo'])
          filterArr.push(item)
        }
      }
      this.harbourSource = filterArr
      this.initData = JSON.parse(JSON.stringify(this.harbourSource))
      const map = {}
      this.initData.map((item) => {
        map[item.soNo] = item
      })
      this.initData = map
      // 处理多个so排序，单条数据关单号更多的先进行比对。
      this.tableList.forEach((item) => {
        // 再次进入时将换行符转换，进行匹配
        item.soNo = item.soNo.replace(/\n/g, ',')
        // soNoArr存储转换后的关单号集合
        if (item.soNo.includes(',')) {
          item.soNoArr = item.soNo.split(',')
        } else {
          item.soNoArr = [item.soNo]
        }
      })
      // 对关单号进行排序
      this.tableList = this.tableList.sort((a, b) => {
        return b.soNoArr.length - a.soNoArr.length
      })
      // 系统录入有多个so的情况处理
      this.tableList.forEach((item) => {
        const mergeData = []
        const mergeArr = []
        // 转换箱型箱种
        this.convert(item)
        // 关单号多于1个的才是多个so的数据
        if (item.soNoArr.length > 1) {
          // 遍历港区数据
          this.harbourSource.forEach((v, i) => {
            v.sealNo = v.sealno
            v.eqTypeArr = CommonUtil.transformationEqType(v.eqType, v.containerHeightCn, this.HQHCFlag)
            this.convert(v)
            // 数组中在港区中有相同关单号 并且 箱型、箱种、箱号、封号相同时，取得港区的数据
            if (
              item.soNoArr.includes(v.soNo) &&
              (!item.eqType || (item.eqType && v.eqTypeArr.includes(item.eqType))) &&
              (!item.eqSize || (item.eqSize && item.eqSize === v.eqSize)) &&
              (!item.containerNo || (item.containerNo && item.containerNo === v.containerNo)) &&
              (!item.sealNo || (item.sealNo && item.sealNo === v.sealNo))) {
              if (v.containerHeightCn) {
                v.eqType = item.eqType
              }
              mergeData.push(v)
              mergeArr.push(v.soNo)
            }
            // 遍历到最后一条时，在港区找到符合的条数和多个so的条数一致，代表当前数据在港区找到匹配，合并港区找到的数据
            if (i === this.harbourSource.length - 1 && mergeData.length === item.soNoArr.length) {
              console.log('mergeData=====', mergeData)
              const unmatchedData = []
              // 遍历港区数据，取出在港区未匹配到的数据重新重新赋值
              this.harbourSource.map((delItem) => {
                if (!mergeArr.includes(delItem.soNo)) {
                  unmatchedData.push(delItem)
                }
              })
              this.harbourSource = unmatchedData
              const sortData = []
              // 对匹配到的港区数据进行排序，顺序和系统录入的保持一致，避免关单号在转成字符串时和系统录入的匹配不上
              item.soNoArr.map((sortItem) => {
                mergeData.map((mergeDataItem) => {
                  if (sortItem === mergeDataItem.soNo) {
                    sortData.push(mergeDataItem)
                  }
                })
              })
              const combineData = {
                soNo: '',
                eqType: '',
                eqSize: '',
                sealNo: '',
                form: 'G',
                containerNo: '',
                weight: 0.000,
                quantity: 0,
                cubage: 0.000,
                detailData: []
              }
              const soNo = []
              // 对匹配到的港区数据进行合并，合并为一条数据
              sortData.map((arrItem) => {
                soNo.push(arrItem.soNo)
                combineData.eqType = arrItem.eqType
                combineData.eqSize = arrItem.eqSize
                combineData.sealNo = arrItem.sealNo
                combineData.containerNo = arrItem.containerNo
                combineData.confirmed = arrItem.confirmed
                combineData.weight = ColumnUtils.formatNumber(Number(combineData.weight) + parseFloat(arrItem.weight), 3)
                combineData.quantity = ColumnUtils.formatNumber(Number(combineData.quantity) + parseFloat(arrItem.quantity), 1)
                combineData.cubage = ColumnUtils.formatNumber(Number(combineData.cubage) + parseFloat(arrItem.cubage), 3)
                // 用于鼠标移入时 分条展示港区数据
                combineData.detailData.push({
                  soNo: arrItem.soNo,
                  weight: arrItem.weight,
                  quantity: arrItem.quantity,
                  cubage: arrItem.cubage
                })
              })
              combineData.soNo = soNo.toString()
              this.harbourSource.push(combineData)
            }
          })
        }
      })
      console.log('this.harbourSource=======', this.harbourSource)
      // 港区数据
      this.harbourSource.forEach((item) => {
        item.rowspan = 1
        item.rowspan1 = 1
        item.rowspan2 = 1
        item.rowspan3 = 1
        item.source = 2
        item.form = 'G'
      })
      const temporarydata = JSON.parse(JSON.stringify(this.harbourSource))
      const newArr = []
      this.tableList.forEach((item, index) => {
        this.convert(item)
        item.rowspan = 1
        item.rowspan1 = 1
        item.rowspan2 = 1
        item.rowspan3 = 1
        item.source = 1
        item.mergeId = index
        newArr.push(item)
        temporarydata.forEach((v, i) => {
          v.sealNo = v.sealno
          v.eqTypeArr = CommonUtil.transformationEqType(v.eqType, v.containerHeightCn, this.HQHCFlag)
          this.convert(v)
          if (item.soNo === v.soNo && ((!item.eqSize && !item.eqType) || (item.eqSize && item.eqSize === v.eqSize && item.eqType && v.eqTypeArr.includes(item.eqType)))) {
            if (v.containerHeightCn) {
              v.eqType = item.eqType
            }
            // 手动更新后再次进入时，港区数据重新获取，所以需要港区的状态值赋值给港区数据
            if (v.confirmed > 0) {
              item.quantity = v.quantity
              item.weight = v.weight
              item.sealNo = v.sealNo
              item.cubage = v.cubage
              item.eqType = v.eqType
              item.eqSize = v.eqSize
              item.containerNo = v.containerNo
              v.type = '保持'
              item.type = '保持'
            } else {
              v.type = item.type
            }
            v.mergeId = index
            newArr.push(...temporarydata.splice(i, 1))
            harbourData.push(v)
          }
        })
      })
      // 录入数据
      newArr.forEach((item) => {
        harbourData.forEach((v) => {
          if ((item.source === 1 && item.mergeId === v.mergeId && item.soNo === v.soNo && v.eqTypeArr.includes(item.eqType) && item.eqSize === v.eqSize && !item.type && !v.confirmed) || (item.mergeId === v.mergeId && item.source === 1 && !item.containerNo && v.eqTypeArr.includes(item.eqType) && item.eqSize === v.eqSize && !item.type && !v.confirmed)) {
            v.type = '修改'
            item.type = '修改'
          }
          if (item.source === 1 && item.mergeId === v.mergeId && item.soNo === v.soNo && !v.eqTypeArr.includes(item.eqType) && item.eqSize !== v.eqSize && !v.confirmed) {
            v.type = '新增'
            item.type = '新增'
          }
        })
      })
      this.tableList = newArr
      this.tableList.forEach((item) => {
        // 录入数据在港区没有找到 则改type为保持
        if (!harbourData.find(target => target.soNo === item.soNo && target.mergeId === item.mergeId) && item.source === 1) {
          item.type = '保持'
        }
      })
      this.getSpanArr()
    },
    // 合并关单号
    getSpanArr() {
      this.tableList.forEach((item, index) => {
        if (item.soNo) {
          // 关单号包含','号则需要换行显示
          if (item.soNo.includes(',')) {
            item.multiline = true
          } else {
            item.multiline = false
          }
          item.soNo = item.soNo.replace(/,/g, '\n')
        }
      })
      // 双层循环
      for (let i = 0; i < this.tableList.length; i++) {
        for (let j = i + 1; j < this.tableList.length; j++) {
          if (this.tableList[i].soNo === this.tableList[j].soNo && this.tableList[i].mergeId === this.tableList[j].mergeId && this.tableList[i].source !== this.tableList[j].source) {
            this.tableList[i].rowspan++
            this.tableList[j].rowspan--
          }
        }
        // 这里跳过已经重复的数据
        i = i + this.tableList[i].rowspan - 1
      }
      this.getSpanArr1()
    },
    // 合并类型
    getSpanArr1() {
      // 双层循环
      for (let i = 0; i < this.tableList.length; i++) {
        for (let j = i + 1; j < this.tableList.length; j++) {
          if (this.tableList[i].soNo === this.tableList[j].soNo && this.tableList[i].mergeId === this.tableList[j].mergeId && this.tableList[i].type === this.tableList[j].type && this.tableList[i].source !== this.tableList[j].source) {
            this.tableList[i].rowspan1++
            this.tableList[j].rowspan1--
          }
        }
        // 这里跳过已经重复的数据
        i = i + this.tableList[i].rowspan1 - 1
      }
      this.getSpanArr2()
    },
    // 合并箱种
    getSpanArr2() {
      // 双层循环
      for (let i = 0; i < this.tableList.length; i++) {
        for (let j = i + 1; j < this.tableList.length; j++) {
          if (this.tableList[i].soNo === this.tableList[j].soNo && this.tableList[i].mergeId === this.tableList[j].mergeId && this.tableList[i].eqSize === this.tableList[j].eqSize && this.tableList[i].source !== this.tableList[j].source) {
            this.tableList[i].rowspan2++
            this.tableList[j].rowspan2--
          }
        }
        // 这里跳过已经重复的数据
        i = i + this.tableList[i].rowspan2 - 1
      }
      this.getSpanArr3()
    },
    // 合并箱型
    getSpanArr3() {
      // 双层循环
      for (let i = 0; i < this.tableList.length; i++) {
        for (let j = i + 1; j < this.tableList.length; j++) {
          if (this.tableList[i].soNo === this.tableList[j].soNo && this.tableList[i].mergeId === this.tableList[j].mergeId && this.tableList[i].eqType === this.tableList[j].eqType && this.tableList[i].source !== this.tableList[j].source) {
            this.tableList[i].rowspan3++
            this.tableList[j].rowspan3--
          }
        }
        // 这里跳过已经重复的数据
        i = i + this.tableList[i].rowspan3 - 1
      }
    },
    // 按照列的顺序合并单元格，如果字段展现顺序改变则合并会出现问题
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 第一列
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        }
      }
      // 第二列
      if (columnIndex === 1) {
        return {
          rowspan: row.rowspan1,
          colspan: 1
        }
      }
      // 第二列
      if (columnIndex === 2) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        }
      }

      if (columnIndex === 3) {
        return {
          rowspan: row.rowspan2,
          colspan: 1
        }
      }

      if (columnIndex === 4) {
        return {
          rowspan: row.rowspan3,
          colspan: 1
        }
      }
    },
    // 设置表格是否可以勾选
    selectable(row, index) {
      if (row.type === '保持') {
        return false
      } else {
        return true
      }
    },
    // 弹窗关闭
    cancel() {
      this.tableList = []
      this.$emit('update:visible', false)
    },
    // 处理表格选中
    handleSelect(selection) {
      const result = []
      this.changeUsage = {}
      this.selectMap = {}
      const harbourDistrict = []
      // 合并的数据勾选后获取到的是合并条数中录入的那条，根据录入的关单号找到港区相同的关单号的数据
      selection.map((item) => {
        this.tableList.map((v) => {
          if (item.soNo === v.soNo && v.source === 2) {
            harbourDistrict.push(v)
          }
        })
      })
      // 勾选中的数据，如果有多个so  则放入数组进行后续判断
      harbourDistrict.forEach((item) => {
        item.soNo = item.soNo.replace(/\n/g, ',')
        this.selectMap[item.soNo] = item
        this.changeUsage[item.soNo] = item.soNo
        // 勾选的数据，如果有多个so  则在初始数据中找到多个so 的uuid和jobUuid
        if (item.soNo.includes(',')) {
          item.soNoArr = item.soNo.split(',')
          item.soNoArr.map((v) => {
            const confirmed = PortDataCompareUtils.getConfirmed(item.type)
            result.push({
              uuid: this.initData[v].uuid,
              confirmed: confirmed,
              jobUuid: this.initData[v].jobUuid
            })
          })
        } else {
          const confirmed = PortDataCompareUtils.getConfirmed(item.type)
          result.push({
            uuid: item.uuid,
            confirmed: confirmed,
            jobUuid: item.jobUuid
          })
        }
      })
      this.selection = result
    },
    // 更新港区数据状态
    sumbitHarbour() {
      if (this.selection.length > 0) {
        // 新增或修改的数据，直接用港区的覆盖掉系统录入的
        this.tableList.forEach((item) => {
          item.soNo = item.soNo.replace(/\n/g, ',')
          if (item.soNo === this.changeUsage[item.soNo] && item.mergeId === this.selectMap[item.soNo].mergeId) {
            const map = this.selectMap[item.soNo]
            item.quantity = map.quantity
            item.weight = map.weight
            item.sealNo = map.sealNo
            item.cubage = map.cubage
            item.eqType = map.eqType
            item.eqSize = map.eqSize
            item.containerNo = map.containerNo
            item.wharfStowageState = map.wharfStowageState
            this.dataSource.forEach((v) => {
              if (v.uuid === item.containerUuid) {
                v.sealNo = map.sealNo
                v.containerNo = map.containerNo
                PortDataCompareUtils.syncPortDate(map, v)
              }
            })
            item.type = '保持'
          }
        })
        this.initTableList.forEach((item) => {
          item.soNo = item.soNo.replace(/\n/g, ',')
          if (item.soNo === this.changeUsage[item.soNo]) {
            const map = this.selectMap[item.soNo]
            item.quantity = map.quantity
            item.weight = map.weight
            item.sealNo = map.sealNo
            item.cubage = map.cubage
            item.eqType = map.eqType
            item.eqSize = map.eqSize
            item.containerNo = map.containerNo
            item.wharfStowageState = map.wharfStowageState
            item.type = '保持'
          }
        })
        this.$emit('addContainer', this.selection)
        this.cancel()
      } else {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
      }
    },
    mappingEqType(scopeRow) {
      if (this.HQHCFlag) {
        return scopeRow.eqType
      }
      if (!scopeRow.isSystemData) {
        if (this.containerHeightFlag) {
          return scopeRow.eqType
        }
        const reflectEqType = scopeRow.eqType
        if (!this.hqFlag || !this.hcFlag) {
          if (this.hqFlag) {
            return reflectEqType.replace('HC', 'HQ')
          }
          return reflectEqType.replace('HQ', 'HC')
        }
      }
      return scopeRow.eqType
    }
  }
}
</script>

<style lang="scss" scoped>
.harbour-data-compare{
  .blue{
    color: blue;
  }
  .none{
    color: #000;
  }
  .harbour-compare-tit{
    margin: 3px 0 8px;
    color: #999;
    font-size: 13px;
    font{
      font-size: 13px;
    }
    p{
      line-height: 26px;
      margin: 0;
      text-indent: 35px;
      font-size: 13px;
    }
  }
}
</style>
<style lang="scss">
.contrast{
  position: relative;
  .cell {
    white-space: pre-wrap !important;
  }
  .floating{
    display: flex;
    flex-direction: column;
    padding: 15px 10px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    background-color: #FFFFFF;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -24%;
    .mar-tp{
      margin-top: 10px;
    }
  }
}
</style>
